export default __webpack_public_path__ + "static/media/Montserrat-LightItalic.d79f80a4.ttf";